import axios from '../axios';

class Api {
    static getListAfdelingteelt (withselect, bedrijf, afdeling, historiek) {
        return axios.get(`/afdelingteelt/list?bedrijf=${bedrijf}&afdeling=${afdeling}&historiek=${historiek}&withselect=${withselect}`);
    }

    static getDetailAfdelingteelt (id) {
        return axios.get(`/afdelingteelt/detail/${id}`);
    }

    static getKlassiekebelichting (id) {
        return axios.get(`/afdelingteelt/klassiek/${id}`);
    }

    static createKlassiekebelichting (payload) {
        return axios.post('/afdelingteelt/klassiek', payload);
    }

    static updateKlassiekebelichting (payload) {
        return axios.post('/afdelingteelt/updtklassiek', payload);
    }

    static getDliprofiel (id) {
        return axios.get(`/afdelingteelt/dliprofiel/${id}`);
    }

    static createVastDliprofiel (payload) {
        return axios.post('/afdelingteelt/vastdliprofiel', payload);
    }

    static createAdaptiefDliprofiel (payload) {
        return axios.post('/afdelingteelt/adaptiefdliprofiel', payload);
    }

    static importBelichtingsschema (formData) {
        return axios.post('/afdelingteelt/uploadklassiek',
            formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    static importDLIProfiel (formData) {
        return axios.post('/afdelingteelt/uploaddliprofiel',
            formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    static updateDliprofiel (payload) {
        return axios.post('/afdelingteelt/updtdliprofiel', payload);
    }

    static getLichtintegratie (id) {
        return axios.get(`/afdelingteelt/lichtintegratie/${id}`);
    }

    static getSamenvatting (id) {
        return axios.get(`/afdelingteelt/samenvatting/${id}`);
    }

    static getWerkelijkebelichting (id) {
        return axios.get(`/afdelingteelt/werkelijk/${id}`);
    }

    static createWerkelijkebelichting (payload) {
        return axios.post('/afdelingteelt/werkelijk', payload);
    }

    static updateWerkelijkebelichting (payload) {
        return axios.post('/afdelingteelt/updtwerkelijk', payload);
    }

    static getVoorstelBelichting (id) {
        return axios.get(`/afdelingteelt/voorstel/${id}`);
    }

    static addAfdelingteelt (payload) {
        return axios.post('/afdelingteelt', payload);
    }

    static updateAfdelingteelt (payload) {
        return axios.post(`/afdelingteelt/update/${payload.id}`, payload);
    }

    static deleteAfdelingteelt (payload) {
        return axios.post(`/afdelingteelt/delete/${payload}`);
    }

    static destroyAfdelingteelt (payload) {
        return axios.post(`/afdelingteelt/destroycomplete/${payload}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/afdelingteelt.js